import { render } from "./CardCalendar.vue?vue&type=template&id=35fedd0e"
import script from "./CardCalendar.vue?vue&type=script&lang=js"
export * from "./CardCalendar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jenna\\Desktop\\Project\\Outsource\\jy-admin2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__